/**
 * 應用程式版本號
 *
 * 部署前必須更新此檔案，並建立獨立 commit：
 * git commit -m "[DeployOnProd] vX.Y.Z YYYYMMDD"
 *
 * 版本格式：
 * - 主版本.次版本.修訂號
 * - 重大更新：主版本 +1
 * - 新功能：次版本 +1
 * - Bug 修正：修訂號 +1
 */
export const VERSION = 'v3.8.8';
export const DEPLOY_DATE = '2026/09/28';
